 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import TITLE from '@/components/Title'
 import PAGE2 from '@/components/Page2'
 import CONTENTS from '@/components/Contents'
 import PAGE4 from '@/components/Page4'
 import FOREWORD from '@/components/Foreword'
 import PAGE6 from '@/components/Page6'
 import CHAPTER1 from '@/components/Chapter1'
 import CHAPTER2 from '@/components/Chapter2'
 import CHAPTER3 from '@/components/Chapter3'
 import CHAPTER4 from '@/components/Chapter4'
 import CHAPTER41 from '@/components/Chapter41'
 import CHAPTER42 from '@/components/Chapter42'
 import CHAPTER43 from '@/components/Chapter43'
 import CHAPTER44 from '@/components/Chapter44'
 import CHAPTER45 from '@/components/Chapter45'
 import CHAPTER46 from '@/components/Chapter46'
 import CHAPTER47 from '@/components/Chapter47'
 import CHAPTER48 from '@/components/Chapter48'
 import CHAPTER49 from '@/components/Chapter49'
 import CHAPTER410 from '@/components/Chapter410'
 import CHAPTER411 from '@/components/Chapter411'
 import CHAPTER412 from '@/components/Chapter412'
 import CHAPTER5 from '@/components/Chapter5'
 import PATTERN_LIBRARY from '@/components/Pattern_library'
 import THANK_YOUS from '@/components/Thank_yous'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Cover",
 			"name" : "Cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/Title",
 			"name" : "Title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/Page2",
 			"name" : "Page2",
 			"component" : PAGE2
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Page4",
 			"name" : "Page4",
 			"component" : PAGE4
 		},
 		{
 			"path" : "/Foreword",
 			"name" : "Foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/Page6",
 			"name" : "Page6",
 			"component" : PAGE6
 		},
 		{
 			"path" : "/Chapter1",
 			"name" : "Chapter1",
 			"component" : CHAPTER1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js